export const ACCESS_AREAS = "7006";
export const ACCESS_GROUPS = "7007";
export const ACCESS_GROUPS_ASSIGNED_ACTIONS = "7110";
export const ACCESS_TIME_PATTERNS = "7008";
export const ACCOUNTS = "7058";
export const EMAIL_ACCOUNTS = "7128";
export const BUILDINGS = "7011";
export const BUILDING_FLOORS = "7120";
export const CARD_FORMATS = "7017";
export const CATEGORIES = "7046"; // Only used for user preferences (column/filters). Not for menu permissions.
export const COMMON_ZONES = "7068";
export const COMPANIES = "7021";
export const CONFIGURATION = "7118";
export const DEPARTMENTS = "7022";
export const DEVICE_TIME_PATTERNS = "7009";
export const DOORS = "7005";
export const ENGINE = "7035";
export const ENROLMENTS = "7010";
export const ENROLMENT_CREDENTIALS = "7105";
export const ENROLMENT_ASSIGNED_ACCESS_GROUPS = "7106";
export const ENROLMENT_ASSIGNED_FLOORS = "7107";
export const ENROLMENT_ASSIGNED_RELATIONSHIPS = "7108";
export const ENROLMENT_ASSIGNED_EXPIRY_REASONS = "7109";
export const EXPIRY_REASONS = "7095";
export const FLOORS = "7142"; // Floors menu straight under Hardware. Not the tab under Buildings.
export const HARDWARE = "7111"; // If this menu is NOT allowed, neither are any of its children
export const HARDWARE_EVENTS = "7112";
export const HARDWARE_INPUTS = "7113";
export const HARDWARE_ACTIONS = "7114";
export const HARDWARE_PARAMS = "7115";
export const HARDWARE_CONTROLLERS = "7004";
export const HARDWARE_BIOMETRICS = "7085";
export const HARDWARE_READERS = "7020";
export const HARDWARE_MODULES = "7123";
export const HOLIDAYS = "7014";
export const HOURS_WORKED = "7032";
export const LIFTS = "7082";
export const MESSAGES = "7016";
export const MODULES = "7122";
export const MONITORING = "7121";
export const MONITORING_DASHBOARD = "7079";
export const MONITORING_TRANSACTIONS = "7026";
export const MONITORING_ALARMS = "7104";
export const PRESETS = "7116"; // Hardware>Presets; Enrolment>Categories; User>Permissions.
export const PRESETS_CONTROLLERS = "7024"; // Only used for user preferences (column/filters). Not for menu permissions.
export const PRESETS_READERS = "7025"; // Only used for user preferences (column/filters). Not for menu permissions.
export const PRESETS_MODULES = "7124"; // Only used for user preferences (column/filters). Not for menu permissions.
export const PRESETS_BIOMETRICS = "7089"; // Only used for user preferences (column/filters). Not for menu permissions.
export const REASON_CODES = "7070";
export const REPORTS = "6005";
export const REPORTS_ABSENTEEISM = "7062"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_ACCESS_GROUPS = "7072"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_AREAS = "7140"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_AUDIT = "7071";
export const REPORTS_CARD_EXPIRY = "7141"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_ENROLMENTS = "7029"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_FIRST_IN_LAST_OUT = "7125"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_HARDWARE_INSTALLATION = "7137"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_HOLIDAYS = "7081"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_TRANSACTION = "7034"; // TODO: possibly remove these, change to DataFilters?
export const REPORTS_TRANSACTION_ALARM = "7126";
export const REPORTS_TRANSACTION_STATUS = "7127";
export const REPORTS_TRANSACTION_DENIED = "7130";
export const REPORTS_TRANSACTION_TIME_ATTENDANCE = "7134";
export const REPORTS_ZONE_OCCUPANCY = "7060";
export const REPORTS_TRANSACTION_VINGCARD = "7139";
export const SCHEDULED_TOURS = "6008";
export const SITES = "6003";
export const SITE_CODES = "7119";
export const THREAT_LEVELS = "";
export const TIME_TRIGGERED_ACTIONS = "7013";
export const USERS = "7117";
export const USER_LOGINS = "7028";
export const USER_PERMISSIONS = "7027"; // Only used for user preferences (column/filters). Not for menu permissions.
export const ZONES = "7015";
export const PRESET_LOCKS = "7131";
export const REPORTS_MUSTERING = "7132";
export const REPORT_STILL_ON_SITE = "7135";
export const ACCESS_PROFILE = "7136";
export const SECURITY_POLICIES = "7138";

export const MENUS: { id: string, name: string, path: string, nameOriginal: string, translationKey: string }[] = [
    {
        id: ENROLMENTS,
        name: "Enrolments",
        path: "/access-control/enrolment",
        nameOriginal: "Enrolments",
        translationKey: "enrolments"
    },
    {
        id: ACCESS_AREAS,
        name: "Access Areas",
        path: "/access-control/enrolment/access-areas",
        nameOriginal: "Access Areas",
        translationKey: "accessAreas"
    },
    {
        id: ACCESS_GROUPS,
        name: "Access Groups",
        path: "/access-control/enrolment/access-groups",
        nameOriginal: "Access Groups",
        translationKey: "accessGroups"
    },
    {
        id: ACCESS_GROUPS,
        name: "Access Profiles",
        path: "/access-control/enrolment/access-profiles",
        nameOriginal: "Access Profiles",
        translationKey: "accessProfiles"
    },
    {
        id: ACCESS_TIME_PATTERNS,
        name: "Access Time Patterns",
        path: "/access-control/enrolment/access-time-patterns",
        nameOriginal: "Access Time Patterns",
        translationKey: "accessTimePatterns"
    },
    {
        id: COMPANIES,
        name: "Companies",
        path: "/access-control/enrolment/companies",
        nameOriginal: "Companies",
        translationKey: "companies"
    },
    {
        id: DEPARTMENTS,
        name: "Departments",
        path: "/access-control/enrolment/departments",
        nameOriginal: "Departments",
        translationKey: "departments"
    },
    {
        id: REPORTS,
        name: "Reports",
        path: "/access-control/reports",
        nameOriginal: "Reports",
        translationKey: "reports"
    },
    {
        id: REPORTS_TRANSACTION,
        name: "Transactions Reports",
        path: "/access-control/reports/transaction-report",
        nameOriginal: "Transactions Reports",
        translationKey: "transactions"
    },
    {
        id: HARDWARE,
        name: "Hardware",
        path: "/access-control/hardware",
        nameOriginal: "Hardware",
        translationKey: "hardware"
    },
    {
        id: BUILDINGS,
        name: "Buildings",
        path: "/access-control/hardware/buildings",
        nameOriginal: "Buildings",
        translationKey: "buildings"
    },
    {
        id: COMMON_ZONES,
        name: "Common Zones",
        path: "/access-control/hardware/common-zones",
        nameOriginal: "Common Zones",
        translationKey: "commonZones"
    },
    {
        id: DEVICE_TIME_PATTERNS,
        name: "Device Time Patterns",
        path: "/access-control/hardware/device-time-patterns",
        nameOriginal: "Device Time Patterns",
        translationKey: "deviceTimePatterns"
    },
    {
        id: DOORS,
        name: "Doors",
        path: "/access-control/hardware/doors",
        nameOriginal: "Doors",
        translationKey: "doors"
    },
    {
        id: FLOORS,
        name: "Floors",
        path: "/access-control/hardware/floors",
        nameOriginal: "Floors",
        translationKey: "floors"
    },
    {
        id: LIFTS,
        name: "Lifts",
        path: "/access-control/hardware/lifts",
        nameOriginal: "Lifts",
        translationKey: "lifts"
    },
    {
        id: PRESETS,
        name: "Presets",
        path: "/access-control/hardware/presets",
        nameOriginal: "Presets",
        translationKey: "presets"
    },
    {
        id: REASON_CODES,
        name: "Reason Codes",
        path: "/access-control/hardware/reason-codes",
        nameOriginal: "Reason Codes",
        translationKey: "reasonCodes"
    },
    {
        id: TIME_TRIGGERED_ACTIONS,
        name: "Time Triggered Actions",
        path: "/access-control/hardware/time-triggered-actions",
        nameOriginal: "Time Triggered Actions",
        translationKey: "timeTriggeredActions"
    },
    {
        id: ZONES,
        name: "Zones",
        path: "/access-control/hardware/zones",
        nameOriginal: "Zones",
        translationKey: "zones"
    },
    {
        id: USER_LOGINS,
        name: "Logins",
        path: "/access-control/operators/logins",
        nameOriginal: "Logins",
        translationKey: "logins"
    },
    {
        id: USER_PERMISSIONS,
        name: "Permissions",
        path: "/access-control/operators/permissions",
        nameOriginal: "Permissions",
        translationKey: "permissions"
    },
    {
        id: CARD_FORMATS,
        name: "Card Formats",
        path: "/access-control/configuration/card-formats",
        nameOriginal: "Card Formats",
        translationKey: "cardFormats"
    },
    {
        id: HOLIDAYS,
        name: "Holidays",
        path: "/access-control/configuration/holidays",
        nameOriginal: "Holidays",
        translationKey: "holidays"
    },
    {
        id: MESSAGES,
        name: "Messages",
        path: "/access-control/configuration/messages",
        nameOriginal: "Messages",
        translationKey: "messages"
    },
    {
        id: SITES,
        name: "Sites",
        path: "/access-control/configuration/sites",
        nameOriginal: "Sites",
        translationKey: "sites"
    },
    {
        id: ACCOUNTS,
        name: "System Accounts",
        path: "/access-control/configuration/accounts",
        nameOriginal: "System Accounts",
        translationKey: "accounts"
    }
] 